module.exports = __webpack_public_path__ + "img/device.preview.c1fc3062.png";